let adminPassword = '';

export const hasAdminPassword = () => adminPassword.trim().length > 0;

export const getAdminPassword = () => adminPassword;

export const setAdminPassword = (value: string) => {
  adminPassword = value.trim();
  return adminPassword;
};

export const clearAdminPassword = () => {
  adminPassword = '';
};